export enum PropertyCategories {
  Buy,
  Rent,
}
